import { Carousel } from "3d-react-carousal";

import "./index.scss";

const ImageSlider = ({ slides }) => (
  <div className="image-slider" id="image-carousel">
    <Carousel slides={slides} autoplay={true} interval={2500} />
  </div>
);

export default ImageSlider;
